export const STORAGE_KEY_PREFIX = 'seen_modal';
